// src/pages/validasi/ValidasiWorkflow.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCapabilities } from '../../hooks/useCapabilities';

const ValidasiWorkflow: React.FC = () => {
  const caps = useCapabilities();

  // Punya validate + level ≤ 1 → halaman warek
  if (caps.canValidate && caps.hasLevel(1)) {
    return <Navigate to="/validasi/level2" replace />;
  }

  // Punya validate + level ≤ 2 → halaman dekan
  if (caps.canValidate && caps.hasLevel(2)) {
    return <Navigate to="/validasi/level1" replace />;
  }

  // Fallback
  return <Navigate to="/dashboard" replace />;
};

export default ValidasiWorkflow;